export const texts = {
  triggerAlt: "Notificaciones",
  unreadBadge: (count: number) => `${count} notificaciones sin leer`
} as const
